import React, { ComponentProps } from 'react';
import { TableOfContentsDefaultView } from './views/TableOfContentsDefaultView';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { murmurhash } from '../../lib/js/hash';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { TableOfContentsEditView } from './views/TableOfContentsEditView';

type TableOfContentsProps = Views<DefaultView<TableOfContentsDefaultView> & EditView<TableOfContentsEditView>>;

function TableOfContents({ views }: TableOfContentsProps) {
  const { t } = useSonTranslation('TableOfContents');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();
  // because of colons in uuid
  const hashedUUID = murmurhash(uuid);

  const blockInteractionButtons = () =>
    createButtonObject(
      BlockInteractionsViews.EDIT,
      Icons.EDIT_PENCIL,
      `${Namespace.TableOfContents}:edit`,
      DISPLAY_TYPE.COLLAPSIBLE,
      <TableOfContentsEditView {...views.edit} />,
    );

  return (
    <BlockInteractions
      headline={{
        text: t('edit.headline'),
        hierarchy: 2,
        visible: true,
      }}
      alwaysShowInfo={false}
      views={{ ...views }}
      buttons={blockInteractionButtons()}
      refreshBlock={refresh}
      refreshCount={refreshCount}
      uuid={hashedUUID}
      elementType={elementType}
    >
      <TableOfContentsDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const TableOfContentsBlock = asFetchableBlock(TableOfContents, BlockType.tableofcontents);
export type TableOfContentsBlock = ComponentProps<typeof TableOfContentsBlock>;
